import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import axios from "axios";
import axiosRetry from "axios-retry";
import { AXIOS_HEADER } from "../config/constants";
import { checkout, clearCart } from "../actions/cartActions";
import { setUserInfo } from "../actions/userActions";
import { spRemoveItem, spClearCart } from "../actions/spCartActions";
import { btnStyle } from "../Styles";
import {
  FormatCurrency,
  generateGuid,
  fullProductImageUrl,
  apiBaseUrl,
} from "../Util";
import { setUserId } from "../actions/userActions";
import { isInStore } from "../store/storeUtil";
import DeliveryFeeCalculator from "../order/DeliveryFeeCalculator";
import ActionConfirmation from "../ActionConfirmation";
import log from "loglevel";
import "../myLogger";
import "../../cart.css";

class CartSum extends Component {
  constructor(props) {
    super(props);
    this.state = {
      foundAddrStr: null,
      addressLine1: null,
      city: null,
      state: null,
      zipCode: null,
      fee: -1,
      deliveryFee: -1,
      dfErrorMessage: null,
      mobileMode: this.props.mobileMode,
      showSignInAtCheckout: this.props.showSignInAtCheckout,
    };
    this.redirectToCheckout = this.redirectToCheckout.bind(this);
    this.emptyCart = this.emptyCart.bind(this);
    this.continueShopping = this.continueShopping.bind(this);
    this.calculateDeliveryFee = this.calculateDeliveryFee.bind(this);
    this.useFoundAddress = this.useFoundAddress.bind(this);
  }
  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    if (this.props.showSignInAtCheckout !== prevProps.showSignInAtCheckout) {
      this.setState({ showSignInAtCheckout: this.props.showSignInAtCheckout });
    }
  }
  redirectToCheckout() {
    let userId = this.props.userId;

    if (userId === null || userId === undefined || userId === "") {
      userId = generateGuid();
      this.props.setUserId(userId);
    }
    if (this.state.showSignInAtCheckout) {
      this.props.history.push("/checkout");
    } else {
      this.props.history.push("/shippingChoice");
    }
  }

  continueShopping() {
    this.props.history.push("/");
  }
  emptyCart() {
    this.props.clearCart();
    this.props.spClearCart();
  }
  isEmpty() {
    let count = this.props.items ? this.props.items.length : 0;
    if (count === 0 && isInStore()) {
      count = this.props.storeItems ? this.props.storeItems.length : 0;
    }
    return count === 0;
  }
  removeItem(item) {
    this.props.spRemoveItem(item.sku);
  }
  getOrderSubtotal() {
    let subtotal = this.props.subtotal;
    const storeItems = this.props.storeItems;
    const discount = this.props.discount;

    if (isInStore() && storeItems && storeItems.length > 0) {
      for (let i = 0; i < storeItems.length; i++) {
        if (
          !storeItems[i].coupon &&
          (!storeItems[i].typeId || storeItems[i].typeId <= 0)
        ) {
          subtotal += storeItems[i].quantity * storeItems[i].price;
        }
      }
    }

    if (discount) subtotal = subtotal - discount.amount;
    return subtotal;
  }
  calculateDeliveryFee(addr) {
    const url = apiBaseUrl() + "GetDeliveryFee";
    const address = {
      ...addr,
      userId: this.props.userId,
    };
    const req = {
      address,
      orderSubtotal: this.getOrderSubtotal(),
    };

    let userInfo = addr;
    if (this.props.userInfo) {
      userInfo = {
        ...this.props.userInfo,
        addressLine1: addr.addressLine1,
        city: addr.city,
        state: addr.state,
        zipCode: addr.zipCode,
      };
    }
    this.props.setUserInfo(userInfo);

    axiosRetry(axios, { retries: 3 });
    axios
      .post(url, req, { headers: AXIOS_HEADER })
      .then((res) => {
        if (res.data && res.data.status) {
          this.setState({ deliveryFee: res.data.fee, dfErrorMessage: null });
        } else {
          if (res.data.found) {
            const addr = res.data.found;
            const str =
              addr.addressLine1 +
              "<br/>" +
              addr.city +
              ", " +
              addr.state +
              " " +
              addr.zipCode;
            const foundAddrStr =
              "We are not able to deliver to the address you provided. " +
              "However, we found the deliverable address below:<p/>" +
              str +
              "<p/>Click Yes if you would like to use this address instead.";
            this.setState({
              addressLine1: addr.addressLine1,
              city: addr.city,
              state: addr.state,
              zipCode: addr.zipCode,
              fee: addr.fee,
              foundAddrStr,
            });
            document.getElementById("hiddenConfirmBtn").click();
          }
          const dfErrorMessage =
            res.data.minAmount > 0
              ? "Sorry, we require minimum purchase of $" +
                res.data.minAmount +
                " to deliver in your area."
              : "Sorry, we don't deliver to your area right now.";
          this.setState({ deliveryFee: -1, dfErrorMessage });
        }
      })
      .catch((error) => {
        this.setState({ dfErrorMessage: "An error has occurred" });
        log.error(error);
      });
  }
  useFoundAddress() {
    this.setState({
      deliveryFee: this.state.fee,
      dfErrorMessage: null,
    });
    let userInfo;
    if (this.props.userInfo) {
      userInfo = {
        ...this.props.userInfo,
        addressLine1: this.state.addressLine1,
        city: this.state.city,
        state: this.state.state,
        zipCode: this.state.zipCode,
      };
    } else {
      userInfo = {
        addressLine1: this.state.addressLine1,
        city: this.state.city,
        state: this.state.state,
        zipCode: this.state.zipCode,
      };
    }
    this.props.setUserInfo(userInfo);
  }
  showDFCDialog() {
    document.getElementById("dfcDialog").click();
  }
  showDFInfo() {
    if (this.state.deliveryFee <= 0) {
      let addressLine1 = "";
      let city = "";
      let zipCode = "";
      let addr = null;

      if (!isInStore()) {
        addr = this.props.deliveryInfo
          ? this.props.deliveryInfo
          : this.props.contactInfo;

        if (!addr) addr = this.props.userInfo;
        if (addr) {
          addressLine1 = addr.addressLine1;
          city = addr.city;
          zipCode = addr.zipCode;
        }
      }

      return (
        <div className="nddiv">
          {this.state.dfErrorMessage && (
            <font color="red">
              {this.state.dfErrorMessage} But you can pickup your furniture at
              our warehouse.
              <p />
            </font>
          )}
          <DeliveryFeeCalculator
            addressLine1={addressLine1}
            city={city}
            zipCode={zipCode}
            actionHandler={this.calculateDeliveryFee}
            hidden={true}
            btnId="dfcDialog"
          />
        </div>
      );
    }
  }
  showDeposits(total) {
    if (
      !isInStore() ||
      !this.props.storeItems ||
      this.props.storeItems.length == 0
    ) {
      return null;
    }
    const storeItems = this.props.storeItems;
    let totalDeposit = 0;
    for (let i = 0; i < storeItems.length; i++) {
      if (storeItems[i].typeId && storeItems[i].typeId > 0) {
        if (storeItems[i].price < 0) totalDeposit -= storeItems[i].price;
        else totalDeposit += storeItems[i].price;
      }
    }
    if (totalDeposit <= 0) return null;

    let remaining = total - totalDeposit;
    if (remaining > 0 && Math.abs(remaining) < 1) remaining = 0;
    return (
      <React.Fragment>
        {storeItems.map((sp) => {
          if (sp.typeId && sp.typeId > 0) {
            const amount = sp.price > 0 ? sp.price : 0 - sp.price;
            const last4 =
              sp.last4 && sp.last4.length > 0 ? "(" + sp.last4 + ")" : null;
            return (
              <React.Fragment>
                <div>
                  {sp.name}
                  {last4}:
                </div>
                <div align="right">
                  {" "}
                  <font color="red">
                    -<FormatCurrency amount={amount} />
                  </font>
                </div>
                <div>
                  <img
                    src={fullProductImageUrl("remove-item.jpg")}
                    height="12"
                    onClick={() => this.removeItem(sp)}
                  ></img>
                </div>
              </React.Fragment>
            );
          }
        })}
        <div>
          <i>Remaning:</i>
        </div>
        <div align="right">
          <FormatCurrency amount={remaining} />
        </div>
        <div>&nbsp;</div>
      </React.Fragment>
    );
  }
  render() {
    if (this.isEmpty() || this.props.show === "false") {
      return "";
    }

    let totalQuant = 0;
    let subtotal = this.props.subtotal;
    for (let i = 0; i < this.props.items.length; i++) {
      totalQuant += this.props.items[i].quantity;
    }

    const storeItems = this.props.storeItems;
    let coupons = [];
    let couponAmount = 0;
    if (isInStore() && storeItems && storeItems.length > 0) {
      for (let i = 0; i < storeItems.length; i++) {
        if (storeItems[i].coupon) {
          coupons.push(storeItems[i]);
          couponAmount += storeItems[i].price;
        } else {
          if (storeItems[i].typeId <= 0) {
            subtotal += storeItems[i].quantity * storeItems[i].price;
            totalQuant += storeItems[i].quantity;
          }
        }
      }
    }

    const discount = this.props.discount;
    if (discount) subtotal = subtotal - discount.amount;

    const tariff =
      this.props.tariffRate && this.props.tariffRate > 0
        ? subtotal * this.props.tariffRate
        : 0;
    const taxRate = this.props.taxRate ? this.props.taxRate : 0.07;
    const taxRatePcnt = "" + (taxRate * 100).toFixed(1) + "%";
    subtotal += tariff;

    const tax = subtotal * taxRate;
    let grandTotal = subtotal + tax + tariff + couponAmount;
    if (this.state.deliveryFee > 0) grandTotal += this.state.deliveryFee;

    return (
      <div>
        <hr />
        <div className="threecol-tbl">
          {discount && (
            <React.Fragment>
              <div>{discount.name}:</div>
              <div align="right">
                <font color="red">
                  -<FormatCurrency amount={discount.amount} />
                </font>
              </div>
              <div>&nbsp;</div>
            </React.Fragment>
          )}
          <div>Subtotal({totalQuant} items):</div>
          <div align="right">
            <FormatCurrency amount={subtotal} />
          </div>
          <div>&nbsp;</div>
          <div>Sales Tax ({taxRatePcnt}):</div>
          <div align="right">
            <FormatCurrency amount={tax} />
          </div>
          <div>&nbsp;</div>
          {this.state.deliveryFee > 0 && (
            <React.Fragment>
              <div>Delivery Fee:</div>
              <div align="right">
                <FormatCurrency amount={this.state.deliveryFee} />
              </div>
              <div>&nbsp;</div>
            </React.Fragment>
          )}
          {coupons.length > 0 &&
            coupons.map((item) => {
              return (
                <React.Fragment>
                  <div>{item.title}:</div>
                  <div align="right">
                    <font color="red">
                      <FormatCurrency amount={item.price} />
                    </font>
                  </div>
                  <div>
                    &nbsp;{" "}
                    <img
                      src={fullProductImageUrl("remove-item.jpg")}
                      height="12"
                      onClick={() => this.removeItem(item)}
                    ></img>
                  </div>
                </React.Fragment>
              );
            })}
          <div>
            <b>Total:</b>
          </div>
          <div align="right">
            <b>
              <FormatCurrency amount={grandTotal} />
            </b>
          </div>
          <div>&nbsp;</div>
          {this.showDeposits(grandTotal)}
        </div>
        {this.state.deliveryFee <= 0 && (
          <div className="nddiv-t10">
            <a href="#" onClick={this.showDFCDialog}>
              Calculate Delivery Fee
            </a>
            <p />
          </div>
        )}
        {this.showDFInfo()}
        <div>
          <button style={btnStyle} onClick={this.continueShopping}>
            Continue Shopping
          </button>
          &nbsp;&nbsp;
          {isInStore() && (
            <span>
              <button style={btnStyle} onClick={this.emptyCart}>
                Empty Cart
              </button>
              &nbsp;&nbsp;
            </span>
          )}
          <button style={btnStyle} onClick={this.redirectToCheckout}>
            <b>Checkout</b>
          </button>
        </div>
        {!isInStore() && (
          <div className="top-10">
            You can choose <i>Delivery</i>, <i>Pickup</i>, or <i>Layaway</i>{" "}
            after you click "Checkout".
          </div>
        )}
        <ActionConfirmation
          hidden={true}
          btnId="hiddenConfirmBtn"
          actionHandler={this.useFoundAddress}
          buttonTitle="Hidden"
          buttonClsName="btn-style"
          title="Use Adddress Below"
          message={this.state.foundAddrStr}
          html={true}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    items: state.cart.addedItems,
    subtotal: state.cart.subtotal,
    discount: state.cart.discount,
    userId: state.user.userId,
    storeId: state.webOrder.storeId,
    storeName: state.webOrder.storeName,
    kiosk: state.webOrder.kiosk,
    storeItems: state.spCart.storeItems,
    android: state.cache.android,
    userInfo: state.user.userInfo,
    contactInfo: state.order.contactInfo,
    deliveryInfo: state.order.deliveryInfo,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    checkout: () => {
      dispatch(checkout());
    },
    setUserId: (userId) => {
      dispatch(setUserId(userId));
    },
    spRemoveItem: (sku) => {
      dispatch(spRemoveItem(sku));
    },
    clearCart: () => {
      dispatch(clearCart());
    },
    spClearCart: () => {
      dispatch(spClearCart());
    },
    setUserInfo: (info) => {
      dispatch(setUserInfo(info));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(CartSum));
